"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
var _elDragDialog = _interopRequireDefault(require("@/directive/el-drag-dialog"));
var _lifehikesInitData = require("@/lifehikes-init-data");
var _resource = require("@/api/resource");
var _log = require("@/utils/log");
var _moment = _interopRequireDefault(require("moment"));
var _cookie = require("@/utils/cookie");
var _ga = require("@/utils/ga");
var _index = _interopRequireDefault(require("../../../components/SearchBox/index.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'ResourceList',
  components: {
    SearchBox: _index.default
  },
  directives: {
    elDragDialog: _elDragDialog.default
  },
  filters: {
    truncate(value, length) {
      return value.substring(0, length) + '......';
    }
  },
  data() {
    return {
      resourceType: _lifehikesInitData.resourceType,
      fullscreenloading: false,
      isDialogShow: false,
      resourceList: null,
      subtypeList: ['event-resource', 'learn-grow-content', 'bubble-coach-content'],
      statuses: ['published', 'archived'],
      total: 0,
      loading: false,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        q: undefined,
        type: undefined,
        category: undefined,
        status: 'published',
        sort: '-updatedAt'
      }
    };
  },
  computed: {
    isRoot() {
      const roles = (0, _cookie.getCookie)('ROLES');
      return roles.indexOf('root') >= 0;
    }
  },
  created() {
    this.getList();
  },
  methods: {
    doCreate() {
      this.$router.push('/resource/create');
    },
    doSearch(pageNo) {
      this.listQuery.page = pageNo;
      this.listQuery.type = this.listQuery.type === '' ? this.listQuery.type = undefined : this.listQuery.type;
      this.listQuery.q = this.listQuery.q === '' ? this.listQuery.q = undefined : this.listQuery.q;
      this.listQuery.category = this.listQuery.category === '' ? this.listQuery.category = undefined : this.listQuery.category;
      this.listQuery.status = this.listQuery.status === '' ? this.listQuery.status = undefined : this.listQuery.status;
      this.getList();
    },
    doDelete(id, title) {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      const oEmail = (0, _cookie.getCookie)('EMAIL');
      this.$confirm(`${this.$i18n.t('otrResource.deleteResource')} [ ${title} ]. ${this.$i18n.t('otrResource.continue')}?`, 'Warning', {
        confirmButtonText: this.$i18n.t('otrResource.ok'),
        cancelButtonText: this.$i18n.t('otrResource.cancel'),
        type: 'warning'
      }).then(() => {
        (0, _resource.deleteResourceById)(token, id).then(response => {
          this.doSearch(this.listQuery.page);
          const msg = this.$i18n.t('otrResource.delete');
          (0, _log.displayPopupMessage)(msg, 'success');
          (0, _ga.writeGaEvent)(this, 'Resource', `${_lifehikesInitData.userEvent.resource.delete}`, oEmail, `Resource ID: ${id}`);
        }).catch(error => {
          (0, _log.displayPopupMessage)(error, 'error');
        });
      }).catch(() => {
        const msg = this.$i18n.t('otrResource.cancelDelete');
        (0, _log.displayPopupMessage)(msg, 'info');
      });
    },
    doView(id) {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      (0, _resource.getResourceById)(token, id).then(response => {
        const data = response.data;
        const url = typeof data.url === 'undefined' ? '' : data.url;
        if (url) {
          window.open(url, '_blank');
        } else {
          const msg = this.$i18n.t('otrResource.errNoFile');
          (0, _log.displayPopupMessage)(msg, 'error');
        }
      }).catch(error => {
        (0, _log.showDebugLog)('Resource-GetResource-API-Error', error);
        (0, _log.displayPopupMessage)(error, 'error');
      });
    },
    getList() {
      this.listLoading = true;
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      (0, _resource.fetchList)(token, this.listQuery).then(response => {
        const data = response.data;
        (0, _log.showDebugLog)('Resource-API-response', response.data);
        this.resourceList = data.rows;
        this.total = data.count;
        this.listLoading = false;
      }).catch(error => {
        (0, _log.showDebugLog)('Resource-API-response', error);
        this.listLoading = false;
        (0, _log.displayPopupMessage)(error, 'error');
      });
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.$parent.$emit('onSelectionChange', val);
    },
    sort(data) {
      const {
        prop,
        order
      } = data;
      if (prop === 'title') {
        order === 'ascending' ? this.listQuery.sort = '+title' : this.listQuery.sort = '-title';
      }
      if (prop === 'type') {
        order === 'ascending' ? this.listQuery.sort = '+type' : this.listQuery.sort = '-type';
      }
      if (prop === 'filename') {
        order === 'ascending' ? this.listQuery.sort = '+filename' : this.listQuery.sort = '-filename';
      }
      if (prop === 'createdAt') {
        order === 'ascending' ? this.listQuery.sort = '+createdAt' : this.listQuery.sort = '-createdAt';
      }
      if (prop === 'updatedAt') {
        order === 'ascending' ? this.listQuery.sort = '+updatedAt' : this.listQuery.sort = '-updatedAt';
      }
      if (prop === 'category') {
        order === 'ascending' ? this.listQuery.sort = '+category' : this.listQuery.sort = '-category';
      }
      this.doSearch(1);
    },
    disableVisble(id) {
      this.$refs[id].visible = false;
    }
  }
};